var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealthCareProvidersIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "doctor-24px",
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M12.444,11.889A4.444,4.444,0,1,0,8,7.444,4.444,4.444,0,0,0,12.444,11.889Z",
    transform: "translate(0.556 0)",
    fill: "#9c8eeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M9.244,13.025l.415-.61a7.778,7.778,0,0,0,3.217.7h.248a7.777,7.777,0,0,0,2.784-.515l.292.429a3.136,3.136,0,0,1,.364,1.081,5.261,5.261,0,0,1,.1,1.172.831.831,0,0,0,.046.334h-.421a.844.844,0,0,0-.765.487l-.767,1.644a.844.844,0,0,0,.765,1.2h1.26V17.278h1.389v1.667h1.2a.844.844,0,0,0,.765-1.2L19.369,16.1a.844.844,0,0,0-.765-.487h-.327a.833.833,0,0,0,.046-.222A6.862,6.862,0,0,0,18.2,13.8a4.682,4.682,0,0,0-.624-1.714l-.054-.08q.084-.007.169-.007A5.308,5.308,0,0,1,23,17.308V22H3V17.308a5.308,5.308,0,0,1,4.916-5.294l-.049.072a4.851,4.851,0,0,0-.676,3.121,7.285,7.285,0,0,0,.147.962,1.666,1.666,0,1,0,1.633-.336,5.572,5.572,0,0,1-.119-.766A3.219,3.219,0,0,1,9.244,13.025Z",
    transform: "translate(0 1)",
    fill: "#9c8eeb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthCareProvidersIcon);
export default __webpack_public_path__ + "static/media/health-care-providers-icon.dc8089e376cfa596d86bbaa51c9c69e0.svg";
export { ForwardRef as ReactComponent };